import { render, staticRenderFns } from "./ArthaudCard.vue?vue&type=template&id=3c2e7128&scoped=true"
import script from "./ArthaudCard.vue?vue&type=script&lang=js"
export * from "./ArthaudCard.vue?vue&type=script&lang=js"
import style0 from "./ArthaudCard.vue?vue&type=style&index=0&id=3c2e7128&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c2e7128",
  null
  
)

export default component.exports